<template>
  <v-menu
    top
    offset-y
  >
    <template v-slot:activator="{on, attrs}">
      <v-btn
        :loading="loading"
        :disabled="$store.getters['directories/loading']"
        bottom
        color="primary"
        dark
        fab
        fixed
        right
        v-bind="attrs"
        v-on="on"
      >
        <v-icon class="white--text">
          mdi-plus
        </v-icon>
      </v-btn>
    </template>

    <v-list class="dialogBackground">
      <v-list-item
        v-for="item in $store.getters['directories/requestTypes']"
        :key="item.id"
        @click="typeClick(item.id)"
      >
        <v-list-item-title class="px-4">
          {{ item.name }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    loading: Boolean
  },

  methods: {
    typeClick (id) {
      this.$emit('click', id)
    }
  }
}
</script>
